// Created by: Imran Khan July 2026
import React from "react";
import { formatCurrency, formatPercent } from "./financialYearUtils";

const KPI_CONFIG = [
  { key: "totalEnquiries", title: "Total Enquiries", icon: "fa-clipboard-list", color: "#7B61FF" },
  { key: "siteVisits", title: "Site Visits", icon: "fa-location-dot", color: "#2196F3" },
  { key: "offersCreated", title: "Offers Created", icon: "fa-file-circle-plus", color: "#00BCD4" },
  { key: "offersSubmitted", title: "Offers Submitted", icon: "fa-file-export", color: "#FF9800" },
  { key: "totalOrders", title: "Total Orders", icon: "fa-cart-shopping", color: "#4CAF50" },
  { key: "ordersCompleted", title: "Orders Completed", icon: "fa-circle-check", color: "#1565C0" },
  { key: "totalRevenue", title: "Total Revenue", icon: "fa-indian-rupee-sign", color: "#5E35B1", isRevenue: true },
];

export default function KpiCardRow({ kpis, onCardClick }) {
  if (!kpis) return null;

  return (
    <div className="fy-kpi-row">
      {KPI_CONFIG.map(({ key, title, icon, color, isRevenue }) => {
        const item = kpis[key] || {};
        const value = isRevenue ? formatCurrency(item.value, "crore") : item.value ?? 0;
        const change = item.changePercent ?? 0;
        const isPositive = change >= 0;

        return (
          <button
            key={key}
            type="button"
            className="fy-kpi-card"
            style={{ borderTopColor: color }}
            onClick={() => onCardClick?.(key)}
          >
            <div className="fy-kpi-icon" style={{ backgroundColor: `${color}20`, color }}>
              <i className={`fa-solid ${icon}`} />
            </div>
            <div className="fy-kpi-content">
              <span className="fy-kpi-title">{title}</span>
              <strong className="fy-kpi-value">{value}</strong>
              <span className={`fy-kpi-change ${isPositive ? "positive" : "negative"}`}>
                {formatPercent(change)} vs Last FY
              </span>
            </div>
          </button>
        );
      })}
    </div>
  );
}
